import sliceCreator from '../../index.jsx';
import {GET_ALL_MONTHLY_TARGETS} from '../../../constants/index.jsx';
const _getAllMonthlyTargetsAction = sliceCreator('GET_ALL_MONTHLY_TARGETS', GET_ALL_MONTHLY_TARGETS, 'get');

const { asyncAction: getAllMonthlyTargetsAction, reducer, clearData: clearGetAllMonthlyTargetsAction } = _getAllMonthlyTargetsAction;

export default reducer;

export {
    getAllMonthlyTargetsAction,
    clearGetAllMonthlyTargetsAction
}
